import { getAuthSession } from '@services/auth';
import useData from '@utils/useData';

export const getUserEmail = async () => {
	const { email } = await getAuthSession();
	return email;
};

export const useUserEmail = () => useData(getUserEmail);
